import { Stack } from '@mui/material'
import React from 'react'

function RightSide() {
    return (
        <Stack className='background' >
            <h2>
                مرحبًا بك في منصة نبني
            </h2>
            <p>
                منصة تجمع بين أصحاب العقارات المتضررين من الصراع والمتبرعين لتمكين التعافي المبكر وإعادة الإعمار
            </p>
        </Stack>)
}

export default RightSide